import { render, staticRenderFns } from "./MultiSelectFilter.vue?vue&type=template&id=394cd61f&scoped=true&"
import script from "./MultiSelectFilter.vue?vue&type=script&lang=js&"
export * from "./MultiSelectFilter.vue?vue&type=script&lang=js&"
import style0 from "./MultiSelectFilter.vue?vue&type=style&index=0&id=394cd61f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "394cd61f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/runner/_work/studio/studio/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib'
installComponents(component, {VChip})
